export async function decrypt(
  encryptedString: string,
  iv: string
): Promise<any> {
  try {
    const bytes = Uint8Array.from(atob(encryptedString), (c) =>
      c.charCodeAt(0)
    );
    const ivBytes = Uint8Array.from(atob(iv), (c) => c.charCodeAt(0));

    const keyBytes = bytes.slice(0, 32);
    const encryptedObjectWithTag = bytes.slice(32, bytes.length);

    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-GCM' },
      false,
      ['decrypt']
    );
    const decryptedBuffer = await window.crypto.subtle.decrypt(
      { name: 'AES-GCM', iv: ivBytes },
      cryptoKey,
      encryptedObjectWithTag
    );

    return JSON.parse(new TextDecoder().decode(decryptedBuffer));
  } catch (e) {
    console.log(e);
  }
}
